export default class {
    constructor({ rut, nombres, apellidos, email, idToken, userType, permisos }){
        this.rut = rut;
        this.nombres = nombres;
        this.apellidos = apellidos;
        this.email = email;
        this.idToken = idToken;
        this.userType = userType;
        this.permisos = permisos;
    }
}